import { useLayoutEffect, useState } from "react";

export default function useDeviceDetect(breaking = 760) {
  const [isMobile, setMobile] = useState(false);

  useLayoutEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth || screen.width;
      setMobile(width < breaking);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useLayoutEffect(() => {
    const userAgent =
      typeof window.navigator === "undefined" ? "" : navigator.userAgent;

    let mobile = Boolean(
      userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
      ),
    );

    if (!mobile) {
      const width = window.innerWidth || screen.width;
      mobile = width < breaking;
    }

    setMobile(mobile);
  }, []);

  return { isMobile };
}
